import React from "react";
import Page from "@jumbo/shared/Page";
import DsokCustomerDetailProvider from "../data/DsokCustomerDetailProvider";
import DsokCustomerAppSettingsPage from "../pages/DsokCustomerAppSettingsPage";

export const dsokCustomerAppSettingsRoute = {
  path: "/dsok/customer-detail/:customerUrl/application-settings",
  element: (
    <DsokCustomerDetailProvider>
      <Page component={DsokCustomerAppSettingsPage} />
    </DsokCustomerDetailProvider>
  ),
};
